import { notification } from "antd";
import {
  CREATE_RESPONSE_REQUEST,
  CREATE_RESPONSE_SUCCESS,
  CREATE_RESPONSE_FAILURE,
} from "../Types";
import { DcOffLineHost } from "../../config";

export const createResponse = (formId, answers) => {
  // On attend un FormData en paramètre (construit dans Share.js)
  return async (dispatch) => {
    dispatch({ type: CREATE_RESPONSE_REQUEST });

    try {
      const response = await fetch(
        `${DcOffLineHost}api/responses/${formId}/submit`,
        {
          method: "POST",
          body: answers, // answers est un FormData
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.message);
      }

      dispatch({ type: CREATE_RESPONSE_SUCCESS, payload: data });

      notification.success({
        message: data?.message,
        duration: 5,
      });

      return data;
    } catch (error) {
      dispatch({ type: CREATE_RESPONSE_FAILURE, payload: error?.message });

      notification.error({
        message: error?.message,
        duration: 5,
      });
    }
  };
};
